module.exports = new __parcel__URL__("pve_gameover_bg.360dd69a.png").toString();